import { TOGGLE_DISCLAIMER, SHOW_DISCLAIMER } from './actionTypes'

export const toggleDisclaimer = () => ({
  type: TOGGLE_DISCLAIMER,
})

export const showDisclaimer = () => ({
  type: SHOW_DISCLAIMER,
})
